<mat-form-field
  class="munily-select-field"
  [appearance]="materialAppearance"
  [floatLabel]="floatLabel"
  [ngClass]="formFieldClasses"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-sf-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <mat-select
    [formControl]="resolvedControl"
    [multiple]="multiple"
    [panelClass]="panelClass"
    [disableOptionCentering]="disableOptionCentering"
    [compareWith]="resolvedCompareWith"
    [placeholder]="placeholder"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onOpenedChange($event)"
  >
    <mat-option *ngFor="let opt of options" [value]="opt.value">
      <ng-container [ngSwitch]="!!opt.labelKey">
        <span *ngSwitchCase="true">{{ opt.labelKey | translate }}</span>
        <span *ngSwitchDefault>{{ opt.label }}</span>
      </ng-container>
    </mat-option>
  </mat-select>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <mat-error *ngIf="showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
